"use client";

import { FC } from 'react';
import Atomic from "./Swap/Atomic"
import { SWRConfig } from 'swr';

const Swap: FC = () => {

  return (
    <div className="text-primary-text z-10">
      <SWRConfig>
        <Atomic />
      </SWRConfig>
    </div >
  )
};


export default Swap;